import WebsiteBehaviors from "../website-behaviors/index.js";

class EdX extends WebsiteBehaviors {
	identifier() {
		return "EdX";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "courses.edx.org");
	}

	styles() {
		// language=CSS
		return `
			.aa-highlight {
				all: unset;
			}

			.aa-right-menu button {
				all: unset;
			}
		`;
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default EdX;
